import { HeadlessForm } from '@universal-ember/form';

<template>
  <HeadlessForm as |form|>
    <form.Field @name="likes" as |field|>
      <field.CheckboxGroup class="my-2 flex flex-col" as |group|>
        <group.Label>I like:</group.Label>
        <div class="flex flex-row space-x-2">
          <group.Checkbox @value="red" as |checkbox|>
            <checkbox.Input />
            <checkbox.Label>Red</checkbox.Label>
          </group.Checkbox>
          <group.Checkbox @value="green" as |checkbox|>
            <checkbox.Input />
            <checkbox.Label>Green</checkbox.Label>
          </group.Checkbox>
          <group.Checkbox @value="blue" as |checkbox|>
            <checkbox.Input />
            <checkbox.Label>Blue</checkbox.Label>
          </group.Checkbox>
        </div>
      </field.CheckboxGroup>
    </form.Field>

    <button type="submit">Submit</button>
  </HeadlessForm>
</template>